import { ErrorMessages } from '@shared/models/error-messages.model';

export const INITIAL_PAGE_ERRORS: ErrorMessages = {
  messages: []
};
